import { Alert, Box, Button, Snackbar, Typography } from "@mui/material";
import CustomDataGrid from "components/tables/CustomDataGrid";

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getBillInvoiceDetails,
  getBillInvoices,
  processBillInvoice,
} from "store/actions";

import { columns } from "./helper";
import BillingInvocieSearch from "components/modals/billingInvoiceSearch";
import BillingInvoiceDetail from "components/modals/billingInvoiceDetail";

const BillingInvoices = () => {
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceDetail, setInvoiceDetail] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [billId, setBillId] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [isError, setIsError] = useState(false);

  const [filters, setFilters] = useState({
    patient_name: "",
    patient_id: null,
    status: "",
    bill_date: null,
    billing_amount: "",
  });
  const [tempFilters, setTempFilters] = useState(filters);
  const practice_id = useSelector(
    (state) => state.auth.authData?.selected_practice,
  );

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async (appliedFilters = {}) => {
    setLoading(true);
    setInvoiceData([]);
    try {
      const payload = { practice_id, ...appliedFilters };
      const res = await getBillInvoices(payload);
      if (res) {
        setInvoiceData(res);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFilters = () => {
    const cleared = {
      patient_name: "",
      patient_id: null,
      status: "",
      bill_date: null,
      billing_amount: "",
    };
    setFilters(cleared);
    fetchInvoices();
  };

  const isFilterApplied = () => {
    return (
      filters.patient_id ||
      filters.status ||
      filters.bill_date ||
      filters.billing_amount ||
      filters.bill_invoice_id
    );
  };

  const fetchInvoiceDetial = async (id) => {
    setInvoiceDetail([]);
    setDetailsOpen(true);
    setLoadingDetails(true);
    setBillId(id);
    try {
      const payload = {
        practice_id,
        bill_id: id,
      };
      const res = await getBillInvoiceDetails(payload);
      if (res) {
        setInvoiceDetail(res);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoadingDetails(false);
    }
  };

  const porcessBill = async (action, extraFields = {}) => {
    setLoadingDetails(true);
    setIsError(false);
    try {
      const payload = {
        practice_id,
        bill_id: billId,
        action,
        ...extraFields,
      };
      const res = await processBillInvoice(payload);

      if (res && res.status === "success") {
        setMessage(`Bill ${billId} ${action} Successfully`);
        setDetailsOpen(false);
        fetchInvoices();
      } else {
        setMessage("Something went wrong, Please try again.");
        setIsError(true);
        setOpenSnackBar(true);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoadingDetails(false);
      setOpenSnackBar(true);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };

  return (
    <Box bgcolor={"white"} p={2}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Billing Invoices</Typography>
        <Box display="flex" gap={1}>
          <Button
            onClick={() => {
              setTempFilters(filters);
              setFilterOpen(true);
            }}
            variant="outlined"
          >
            Search
          </Button>
          {isFilterApplied() && (
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              color="secondary"
            >
              Clear Filters
            </Button>
          )}
        </Box>
      </Box>

      <CustomDataGrid
        rows={invoiceData}
        columns={columns({ fetchDetails: fetchInvoiceDetial, isDetail: false })}
        getRowId={(row) => row.bill_id}
        loading={loading}
      />
      <BillingInvocieSearch
        fetchInvoices={fetchInvoices}
        filterOpen={filterOpen}
        filters={filters}
        setFilterOpen={setFilterOpen}
        setFilters={setFilters}
        setTempFilters={setTempFilters}
        tempFilters={tempFilters}
      />
      <BillingInvoiceDetail
        detailsOpen={detailsOpen}
        setDetailsOpen={setDetailsOpen}
        invoiceDetail={invoiceDetail}
        loadingDetails={loadingDetails}
        porcessBill={porcessBill}
      />
      <Snackbar
        open={openSnackBar}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={isError ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BillingInvoices;
